import { IconArrowLeft, IconArrowRight, IconSparkles } from "@tabler/icons-react";
import C1_Image from "../../assets/images/partner/Generous Earnings.svg";
import C2_Image from "../../assets/images/partner/Zero Setup Hassle.svg";
import C3_Image from "../../assets/images/partner/Demonstrable ROI.svg";
import C4_Image from "../../assets/images/partner/Marketing & Sales Materials.svg";
import C5_Image from "../../assets/images/partner/Dedicated Support.svg";
import Slider from "react-slick";
import { useRef } from "react";

const Section5 = () => {

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };

    const settings = {
    dots: false,
    infinite: true,
    centerPadding: "10px",
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    cssEase: "linear",
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow : 1,
                slidesToScroll : 1,
                autoplay: true,
                autoplaySpeed: 7000,
                cssEase: "linear"
            }
        }
    ]
    };
  const sliderdata = [
    {
      img: C1_Image,
      t1: "Generous Earnings",
      t2: "Offer our platform as your own or earn commission—flexible pricing and full white-labeling included."
    },
    {
      img: C2_Image,
      t1: "Zero Setup Hassle",
      t2: "Our team handles all integrations and dispute submissions. You focus on relationships."
    },
    {
      img: C3_Image,
      t1: "Demonstrable ROI",
      t2: "Your clients recover thousands in lost revenue, improve margins and strengthen their financial health."
    },
    {
      img: C4_Image,
      t1: "Marketing & Sales Materials",
      t2: "Access case studies, pitch decks and co-branded content to aid your outreach."
    },
    {
      img: C5_Image,
      t1: "Dedicated Support",
      t2: "Our partnerships team offers training and co-selling to ensure your success."
    }
  ];

  return (
    <div className="s5-partner f-width m-auto">
        <div className="blur-color-1 rounded-pill"></div>
        <div className="blur-color-2 rounded-pill"></div>
      <p className="s4-h-text text-center">
        <IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" width="34" height="34" /> Why Partner with Voosh?</p>

      {/* slider cards */}
      <div className="s5-slider slider-container">
        <div style={{ textAlign: "center" }}>
            <button className="btn btn-prev-next rounded-pill" onClick={previous}>
                <IconArrowLeft className="arrow-on-hover" />
            </button>
            <button className="btn btn-prev-next rounded-pill" onClick={next}>
                <IconArrowRight className="arrow-on-hover" />
            </button>
        </div>
        <Slider
        ref={slider => {
          sliderRef = slider;
        }}
        {...settings}
        >
        {sliderdata.map((item, index) => (
          <div key={index} className="s5-slider-card rounded">
            <img src={item.img} alt={item.t1} />
            <p className="card-t1">{item.t1}</p>
            <p className="card-t2">{item.t2}</p>
          </div>
        ))}
        </Slider>
      </div>
    </div>
  );
};

export default Section5;
